module.exports = __webpack_public_path__ + "images/bourguignon_smallee73bd39c073233ce756f7911386ed88.png";